import { ComponentKey } from "@certa/studio-core/src/constants/process.constants";
import { useProcessDetailsStore } from "../store/processDetails.store";
import { studioState } from "@certa/studio/api";
import type { Field, Step, Swimlane } from "@certa/studio-core";
import { getPreviewIdFromTag } from "./transformMetaJSONToPlatformAPIData";

export const focusPreviewComponentInView = ({
  processId,
  componentType,
  ...props
}: {
  processId: string;
  componentType:
    | ComponentKey.SWIMLANES
    | ComponentKey.STEPS
    | ComponentKey.FIELDS;
} & (
  | {
      componentId: string;
    }
  | {
      componentTag: string;
    }
)) => {
  let componentTag: string | undefined = undefined;

  if ("componentTag" in props) {
    componentTag = props.componentTag;
  } else if ("componentId" in props) {
    const component = studioState().getComponent(
      processId,
      componentType,
      props.componentId
    ) as Swimlane | Step | Field | undefined;
    componentTag = component?.tag;
  }

  if (!componentTag) {
    return;
  }

  const { setSelectedStepByTag } = useProcessDetailsStore.getState();

  let componentDOMId: string | null = null;

  if (componentType === ComponentKey.FIELDS) {
    const fieldId = studioState().getFieldByTag(processId, componentTag)?.id;
    if (!fieldId) return;

    // This is an O(N^2) operation, we could've used lookup here O(1)
    // But lookup might not get the latest data if you are focusing a newly added field
    const parentStep = studioState().getStepByFieldId(processId, fieldId);
    if (!parentStep) return;

    // Select parent step, so that field is rendered
    setSelectedStepByTag(parentStep.tag);
    // Also focus it, to make sure it's in view
    focusPreviewComponentInView({
      processId,
      componentType: ComponentKey.STEPS,
      componentTag: parentStep.tag
    });

    componentDOMId = `field-${getPreviewIdFromTag(componentTag)}`;
  } else if (componentType === ComponentKey.STEPS) {
    componentDOMId = `${getPreviewIdFromTag(componentTag)}`;
  } else if (componentType === ComponentKey.SWIMLANES) {
    componentDOMId = `${getPreviewIdFromTag(componentTag)}`;
  }

  if (componentDOMId) {
    // A delay is needed for step fields to be rendered after the step is selected
    setTimeout(() => {
      const element = document.getElementById(componentDOMId);
      element?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 100);
  }
};
